import { ChevronLeft } from '@mui/icons-material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom/cjs/react-router-dom.min';
import ComponentTable from '../../components/ComponentTable';
import models_V2Service from '../../services/models_V2.service';
import quizService from '../../services/quiz.service';

export const QuizTeacherStatisticPage = () => {
    const { teacher_id } = useParams();
    const { t } = useTranslation();
    const history = useHistory();
    const { info, emulation } = useSelector(state => state.user);

    const role_id = emulation.length ? emulation[emulation.length - 1].info.role_id : info.role_id;

    const isFranch = role_id === 3 ? 'Franch' : '';

    const actions = [
        {
            title: t('quiz.more'),
            onClick: (_, row) => history.push(`/quizzesStatistic${isFranch}/teacher/quiz/${row.id}`),
            outOfMenu: true,
            Icon: OpenInNewIcon,
        },
    ];
    return (
        <>
            {isFranch && (
                <Button
                    onClick={() => history.push(`/quizzesStatistic${isFranch}`)}
                    startIcon={<ChevronLeft />}
                    // variant={'outlined'}
                >
                    <Typography>{t('quiz.back')}</Typography>
                </Button>
            )}

            <Typography component="h2" className="container-header" pb={1}>
                {' '}
                {t('quiz.teacherStatistics')}
            </Typography>

            <ComponentTable
                source={{
                    getData: (page, size, sort, filter) =>
                        quizService.GetQuizStatisticTeacher(false, {
                            page: page || 0,
                            size: size || 10,
                            orderBy: (sort && sort.orderBy) || 'updated_at',
                            order: (sort && sort.order) || 'asc',
                            teacher_id: teacher_id,
                            filter,
                        }),
                    getModel: () => models_V2Service.QuizzesStatisticTeacher(false),
                }}
                actions={actions}
                selectable={true}
                enableFilter={true}
                title={t('modals.list')}
                enableSettings
                toolbarvisible={true}
                typeTable="quizzes_statistic"
            />
        </>
    );
};
